import MioraPlatform from './MioraPlatform';

function App() {
  return <MioraPlatform />;
}

export default App;
